import axios, { AxiosRequestConfig } from "axios";
import getMsalInstance, { loginRequest } from "./getMsalInstance";
import { logger } from "../services/loggingService";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const msalInstance = getMsalInstance();

const instance = axios.create({
    baseURL: "", // You may want to strongly type this later
});

// Add TypeScript annotations for request interceptor
instance.interceptors.request.use(
    async (req: AxiosRequestConfig) => {
        try {
            const account = msalInstance.getActiveAccount();
            if (!account) {
                throw new Error("No active account found");
            }

            const validScopes = (loginRequest.scopes ?? []).filter((scope): scope is string => scope !== undefined);

            const tokenResponse = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account,
                scopes: validScopes,
            });

            if (req.headers) {
                req.headers["Authorization"] = `Bearer ${tokenResponse.accessToken}`;
            } else {
                req.headers = {
                    Authorization: `Bearer ${tokenResponse.accessToken}`,
                };
            }

            return req;
        } catch (error: unknown) {
            if (error instanceof InteractionRequiredAuthError) {
                logger.error(error, "Failed to acquire token silently");
                sessionStorage.setItem("loginMessage", "Login with Microsoft");
                const validScopesForRedirect = loginRequest.scopes.filter((scope): scope is string => scope !== undefined);
                msalInstance.loginRedirect({
                    ...loginRequest,
                    scopes: validScopesForRedirect,
                });
            } else {
                logger.error(error, "Unexpected auth error");
                throw error;
            }
        }

        return req; // fallback (needed to satisfy return)
    },
    (err) => {
        logger.error(err, "Bearer Axios error");
        return Promise.reject(err);
    }
);

export default instance;
